export function calculateTotalInvestors(investments: { investors?: unknown[] }[]): number {
  return investments.reduce((total, investment) => {
    const numInvestors = investment.investors?.length ?? 0;
    return total + (numInvestors > 0 ? numInvestors : 1);
  }, 0);
}
